module.exports = __webpack_public_path__ + "static/media/mmume_03.4cb9564e.png";